import styled from "styled-components";

export const StyledSlider = styled.div`
    width: 100%;
    padding: 0 10px;

    .rc-slider {
        position: relative;
        height: 14px;
        padding: 5px 0;
        width: 100%;
        touch-action: none;

        .rc-slider-rail {
            position: absolute;
            width: 100%;
            background-color: #e9e9e9;
            height: 4px;
        }

        .rc-slider-track {
            position: absolute;
            left: 0;
            height: 3px;
            background-color: ${({ theme }) => theme.colors.secondary[700]};
        }

        .rc-slider-handle {
            position: absolute;
            width: 30px;
            height: 30px;
            cursor: pointer;
            cursor: -webkit-grab;
            margin-top: -13px;
            cursor: grab;
            border-radius: 50%;
            border: solid 2px #e9e9e9;
            background-color: #fff;
            touch-action: pan-x;

            &:focus {
                outline: none;
            }

            &:active {
                border-color: ${({ theme }) => theme.colors.secondary[700]};
                cursor: grabbing;
            }
        }
    }
`;
